import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing }) => ({
  formContainer: {
    // Override FormInputRow description wrapper max-width for better layout
    '& .descriptionWrapper, & .MuiGrid-root.descriptionWrapper, & [class*="descriptionWrapper"]': {
      maxWidth: spacing(27)
    }
  },
  formField: {
    paddingTop: spacing(1)
  }
}))
